module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_4_ov-7f483892828e8d7e4a93bc26bca6672d.gif";